import { crudMdActions } from "@/services/crud-md-actions";

const name = "document-templates";

export default {
  name,
  ...crudMdActions(name),
};
